import { useCallback } from 'react';
import { useIntegrationsApi } from '../api';
import { CreateIntegrationRequestData, GetHookDeliveriesParams, UpdateIntegrationRequestData } from '../types';

export const useIntegrationService = () => {
  const api = useIntegrationsApi();

  const getIntegration = useCallback(async (integrationId: string, companyId: string) => {
    const response = await api.getIntegration(integrationId, companyId);
    return response.data;
  }, []);

  const getHookDeliveries = useCallback(
    async (integrationId: string, params: GetHookDeliveriesParams) => {
      const response = await api.getHookDeliveries(integrationId, params);
      return response.data;
    },
    [],
  );

  const createIntegration = useCallback(
    async (data: CreateIntegrationRequestData, companyId: string) => {
      const response = await api.createIntegration(data, companyId);
      return response.data;
    },
    [],
  );

  const updateIntegration = useCallback(
    async (data: UpdateIntegrationRequestData, integrationId: string, companyId: string) => {
      const response = await api.updateIntegration(data, integrationId, companyId);
      return response.data;
    },
    [],
  );

  const pauseIntegration = useCallback(async (integrationId: string, companyId: string) => {
    const response = await api.pauseIntegration(integrationId, companyId);
    return response.data;
  }, []);

  const activateIntegration = useCallback(async (integrationId: string, companyId: string) => {
    const response = await api.activateIntegration(integrationId, companyId);
    return response.data;
  }, []);

  const deleteIntegration = useCallback(async (integrationId: string, companyId: string) => {
    await api.deleteIntegration(integrationId, companyId);
  }, []);

  return {
    getIntegration,
    getHookDeliveries,
    createIntegration,
    updateIntegration,
    pauseIntegration,
    activateIntegration,
    deleteIntegration,
  };
};
